import { useState } from 'react';
import api from '@/lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Download, Upload, FileSpreadsheet, Users, ShoppingCart } from 'lucide-react';

export default function ImportExport() {
  const [importing, setImporting] = useState(false);
  const [result, setResult] = useState(null);

  const handleExport = async (type) => {
    try {
      const res = await api.get(`/tenant/${type}/export`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const a = document.createElement('a'); a.href = url;
      a.download = `${type}_${new Date().toISOString().slice(0, 10)}.csv`;
      a.click(); window.URL.revokeObjectURL(url);
    } catch { alert('Gagal export'); }
  };

  const handleImport = async (e, type) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setImporting(true); setResult(null);
    const fd = new FormData(); fd.append('file', file);
    try {
      const res = await api.post(`/tenant/${type}/import`, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      setResult(res.data);
    } catch { alert('Gagal import'); }
    setImporting(false);
    e.target.value = '';
  };

  return (
    <div>
      <h1 className="text-2xl font-bold tracking-tight text-slate-900 mb-6" style={{ fontFamily: 'Plus Jakarta Sans' }}>Import / Export Data</h1>
      <Tabs defaultValue="products">
        <TabsList className="mb-4">
          <TabsTrigger value="products"><FileSpreadsheet size={14} className="mr-1" /> Produk</TabsTrigger>
          <TabsTrigger value="customers"><Users size={14} className="mr-1" /> Pelanggan</TabsTrigger>
          <TabsTrigger value="orders"><ShoppingCart size={14} className="mr-1" /> Pesanan</TabsTrigger>
        </TabsList>

        {['products', 'customers', 'orders'].map(type => (
          <TabsContent key={type} value={type}>
            <div className="grid gap-4 md:grid-cols-2">
              <Card className="border-slate-200">
                <CardHeader><CardTitle className="text-base flex items-center gap-2"><Download size={16} /> Export {type === 'products' ? 'Produk' : type === 'customers' ? 'Pelanggan' : 'Pesanan'}</CardTitle></CardHeader>
                <CardContent>
                  <p className="text-sm text-slate-500 mb-4">Download semua data {type === 'products' ? 'produk' : type === 'customers' ? 'pelanggan' : 'pesanan'} dalam format CSV.</p>
                  <Button onClick={() => handleExport(type)} className="bg-[#2D6CDF] hover:bg-[#1A5BC4]">
                    <Download size={14} className="mr-2" /> Download CSV
                  </Button>
                </CardContent>
              </Card>

              {type !== 'orders' && (
                <Card className="border-slate-200">
                  <CardHeader><CardTitle className="text-base flex items-center gap-2"><Upload size={16} /> Import {type === 'products' ? 'Produk' : 'Pelanggan'}</CardTitle></CardHeader>
                  <CardContent>
                    <p className="text-sm text-slate-500 mb-2">Upload file CSV untuk import data. Format kolom:</p>
                    <p className="text-xs text-slate-400 mb-4 font-mono">
                      {type === 'products' ? 'name, price, stock, type, description' : 'name, email, phone, address, tags'}
                    </p>
                    <label>
                      <Button variant="outline" asChild disabled={importing}>
                        <span><Upload size={14} className="mr-2" />{importing ? 'Mengimport...' : 'Upload CSV'}</span>
                      </Button>
                      <input type="file" accept=".csv" className="hidden" onChange={(e) => handleImport(e, type)} />
                    </label>
                  </CardContent>
                </Card>
              )}
            </div>

            {result && (
              <Card className="mt-4 border-emerald-200 bg-emerald-50">
                <CardContent className="pt-4">
                  <p className="text-sm font-medium text-emerald-800">
                    Import selesai: {result.imported} data baru, {result.skipped} dilewati (duplikat)
                  </p>
                  {result.errors?.length > 0 && (
                    <div className="mt-2 text-xs text-red-600">
                      {result.errors.map((err, i) => <p key={i}>{err}</p>)}
                    </div>
                  )}
                </CardContent>
              </Card>
            )}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
